import InstagramAuth from './components/InstagramAuth';
import InstagramAuthContainer from './containers/InstagramAuth';

export default InstagramAuthContainer(InstagramAuth);
